// Agent-orchestration diagram copy. Source/output labels are zipped by index
// against the icon/color data in the component.
const agentPipeline = {
  ariaSection: 'How an AI agent pipeline works',
  eyebrow: 'AI automation',
  title: 'One agent, wired to everything you use',
  lead:
    'Your sources flow into an orchestrated agent that reasons over them and takes action, with a human in the loop where it matters.',
  sources: ['Documents', 'Your database', 'Web & APIs'],
  coreLabel: 'AI Agent',
  coreSub: 'reason · plan · act',
  outputs: ['Cited answers', 'Actions & email', 'Triggers'],
};

export default agentPipeline;
